import { useLayoutEffect } from "react";

function scrollDocumentToTop() {
  if (typeof window === "undefined") return;
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  const root = document.scrollingElement || document.documentElement;
  if (root) root.scrollTop = 0;
  if (document.body) document.body.scrollTop = 0;
}

/**
 * Scroll the viewport to top after route content is in the DOM.
 * useLayoutEffect + delayed passes catch layout/paint that runs after first frame.
 */
export function useDemoScrollToTop(deps) {
  useLayoutEffect(() => {
    scrollDocumentToTop();
    const raf = window.requestAnimationFrame(() => {
      scrollDocumentToTop();
      window.requestAnimationFrame(scrollDocumentToTop);
    });
    const t0 = window.setTimeout(scrollDocumentToTop, 0);
    const t1 = window.setTimeout(scrollDocumentToTop, 100);
    return () => {
      window.cancelAnimationFrame(raf);
      window.clearTimeout(t0);
      window.clearTimeout(t1);
    };
  }, deps);
}
